// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__KjbNE","additionalInfo":"AgreementModal_additionalInfo__2IyaT"};